import { motion } from 'framer-motion'

export default function Cta() {
  return (
    <motion.section
      className="relative w-full bg-surface-dark py-20 md:py-28 overflow-hidden flex flex-col items-center justify-center text-center"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-100px' }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <div className="absolute inset-0 bg-medical-lines-dark pointer-events-none" />

      <div className="relative z-10 max-w-3xl px-6 flex flex-col items-center">
        <h2 className="text-[26px] sm:text-[32px] md:text-[42px] font-extrabold tracking-tight leading-tight mb-6">
          <span className="text-text-on-dark block">
            Sua carreira merece mais proteção.
          </span>
          <span className="text-accent-primary block">
            E isso custa menos que uma consulta.
          </span>
        </h2>

        <p className="text-base md:text-[18px] text-text-on-dark-muted font-normal max-w-xl mb-10 md:mb-12">
          A partir de R$197/mês, você conta com documentos prontos, proteção
          contínua e advogados especializados.
        </p>

        <div className="flex flex-col items-center gap-6">
          <a
            href="#"
            onClick={(event) => event.preventDefault()}
            className="rounded-button bg-accent-primary text-text-on-accent px-10 py-4 font-bold text-[16px] shadow-sm hover:shadow-md hover:bg-accent-hover active:scale-95 transition-all duration-300"
          >
            Quero me proteger agora
          </a>
          <a
            href="#planos"
            className="text-text-on-dark-muted underline decoration-white/30 hover:text-white transition-colors text-[14px]"
          >
            Conheça os planos a partir de R$197/mês
          </a>
        </div>
      </div>
    </motion.section>
  )
}
